
import { InventoryPdgUniqueCategoryGroupCombinationDto} from './inventory-pdg-unique-category-group-container-dto.model';
export class InventoryPdgUniqueCategoryGroupContainer {
   uniqueCategoryGroupCombinationContainers: Array<InventoryPdgUniqueCategoryGroupCombinationDto>;  
  }